import { render, staticRenderFns } from "./ErrorTmz.vue?vue&type=template&id=5a33834c&scoped=true&"
import script from "./ErrorTmz.vue?vue&type=script&lang=js&"
export * from "./ErrorTmz.vue?vue&type=script&lang=js&"
import style0 from "./ErrorTmz.vue?vue&type=style&index=0&id=5a33834c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a33834c",
  null
  
)

export default component.exports